export const DASHBOARD = "dashboard";
export const CUSTOMERS = "customers";
export const PRODUCTS = "products";
export const ORDERS = "orders";
export const INVOICES = "invoices";
export const DEPOSITS = "deposits";
export const TRANSACTIONS = 'transactions';
export const REPORTS = 'reports';
export const SETTINGS = 'settings';
